export default __webpack_public_path__ + "static/media/drawgame-manual-entry.2f59106a.webm";